<template>
  <div>
    <enrollment-header />
    <enrollment-navigation-drawer :items="items" />
    <v-main class="pl-1 pt-3">
      <router-view />
    </v-main>
    <enrollment-footer />
  </div>
</template>

<script>
import Header from '@/components/core/Header.vue';
import NavigationDrawer from '@/components/core/NavigationDrawer.vue';
import Footer from '@/components/core/Footer.vue';
import { canAccessDiagnosticCustomization } from '@/utils/diagnosticPermissions';
import { isInternalEmail } from '@/utils/user';
import { featureSupportRequests } from '@/config/featureFlags';

export default {
  name: 'DashboardLayout',
  components: {
    EnrollmentHeader: Header,
    EnrollmentNavigationDrawer: NavigationDrawer,
    EnrollmentFooter: Footer,
  },
  computed: {
    canAccessDiagnostics() {
      return canAccessDiagnosticCustomization(this.$store.getters.currentUserEmail);
    },
    canAccessDemos() {
      return isInternalEmail(this.$store.getters.currentUserEmail);
    },
    items() {
      const baseItems = [
        { title: this.$t('navigation.colleges'), path: '/dashboard/colleges' },
        { title: this.$t('navigation.students'), path: '/dashboard/students' },
        { title: this.$t('navigation.teachers'), path: '/dashboard/teachers' },
        { title: this.$t('navigation.users'), path: '/dashboard/users' },
        { title: this.$t('navigation.directive_admins'), path: '/dashboard/directive-admins' },
        { title: this.$t('navigation.conglomerates'), path: '/dashboard/conglomerates' },
        { title: this.$t('navigation.district_admins'), path: '/dashboard/district-admins' },
        { title: this.$t('navigation.campus_group_admins'), path: '/dashboard/campus-group-admins' },
        { title: this.$t('navigation.calendar_types'), path: '/dashboard/calendar-types' },
        {
          title: this.$t('navigation.surveys'),
          path: '/dashboard/surveys',
        },
        {
          title: this.$t('navigation.integrations'),
          path: '/dashboard/integrations/classlink',
        },
        {
          title: this.$t('navigation.admin_action_logs'),
          path: '/dashboard/admin-action-logs',
        },
      ];

      if (featureSupportRequests) {
        baseItems.push({
          title: this.$t('navigation.support_requests'),
          path: '/dashboard/support-requests',
        });
      }

      if (this.canAccessDiagnostics) {
        baseItems.push({ title: this.$t('navigation.diagnostics'), path: '/dashboard/diagnostics' });
      }

      if (this.canAccessDemos) {
        baseItems.push({ title: this.$t('navigation.demos'), path: '/dashboard/demos' });
      }

      baseItems.push({ title: this.$t('navigation.school_admin'), path: '/school/admin' });

      return baseItems;
    },
  },
};
</script>
